import api from './api'
import {
  llmModelsCatalogResponseSchema,
  type LLMModelsCatalogResponse,
  type LLMProviderValue,
} from '@/schemas/llm-models'
import type { AxiosRequestConfig } from 'axios'

/**
 * Phase 4 plan 04-04: API client for the catalog endpoint delivered by plan 04-03.
 *
 * Responses are validated against `llmModelsCatalogResponseSchema` so consumers
 * get parsed Zod output (capabilities etc.) rather than raw JSON. The store
 * layer caches results per-provider for 5 minutes (see `stores/llm-models-store`).
 */
export const llmModelsService = {
  async listModels(
    provider: LLMProviderValue,
    config?: AxiosRequestConfig
  ): Promise<LLMModelsCatalogResponse> {
    const response = await api.get('/llm-models', {
      params: { provider },
      ...config,
    })
    return llmModelsCatalogResponseSchema.parse(response.data)
  },
}
